"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../../../../../common/helpers/time");
var InstructorRequestTimeOffRangeController = /** @class */ (function () {
    function InstructorRequestTimeOffRangeController(UserService, $stateParams, $state, UsersModel, TimeoffRequestsModel, FlashService) {
        this.UserService = UserService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.TimeoffRequestsModel = TimeoffRequestsModel;
        this.FlashService = FlashService;
        this.currentUser = UserService.getCurrentUser();
        this.today = new Date();
        this.dateRangeInvalid = false;
        this.dateRangeInvalidMessage = "";
        this.request = {
            request_begin: null,
            request_end: null,
        };
        this.handleDateChange = this.handleDateChange.bind(this);
    }
    InstructorRequestTimeOffRangeController.prototype.handleDateChange = function (newDate) {
        if (newDate.name === "request_begin") {
            this.request.request_begin = newDate.selected[0];
        }
        else if (newDate.name === "request_end") {
            this.request.request_end = newDate.selected[0];
        }
        this.checkForInvalidDate();
    };
    InstructorRequestTimeOffRangeController.prototype.checkForInvalidDate = function () {
        if (this.request.request_begin === null ||
            this.request.request_end === null) {
            this.dateRangeInvalid = true;
            this.dateRangeInvalidMessage = "A begin and end date is required.";
            return true;
        }
        var begin = new Date(this.request.request_begin);
        var end = new Date(this.request.request_end);
        if ((0, time_1.isBefore)(end, begin)) {
            this.dateRangeInvalid = true;
            this.dateRangeInvalidMessage =
                "The end date is before the beginning date.";
            return true;
        }
        if ((0, time_1.isAfter)(begin, end)) {
            this.dateRangeInvalid = true;
            this.dateRangeInvalidMessage =
                "The beginning date is before the ending date.";
            return true;
        }
        this.dateRangeInvalid = false;
        this.dateRangeInvalidMessage = "";
        return false;
    };
    InstructorRequestTimeOffRangeController.prototype.submitRangeRequest = function (isValid) {
        var _this = this;
        this.submitted = true;
        if (isValid) {
            var beginDate = new Date(this.request.request_begin);
            var endDate = new Date(this.request.request_end);
            endDate.setHours(23, 59, 0, 0);
            var request = {
                user_id: this.$stateParams.instructorId,
                begin: (0, time_1.formatDateTime)(beginDate, "YYYY-MM-DD HH:mm:ss"),
                end: (0, time_1.formatDateTime)(endDate, "YYYY-MM-DD HH:mm:ss"),
                type: "range",
                status: "Pending",
                reason: this.request.reason,
            };
            this.TimeoffRequestsModel.create(request).then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.submitted = false;
                _this.$state.go("drivecoach.admin.instructors.view.timeoffrequests", { instructorId: _this.$stateParams.instructorId }, { reload: true });
            });
        }
        else {
            this.FlashService.setMessage({
                type: "error",
                message: "The form is invalid.",
            });
        }
    };
    return InstructorRequestTimeOffRangeController;
}());
InstructorRequestTimeOffRangeController.$inject = [
    "UserService",
    "$stateParams",
    "$state",
    "UsersModel",
    "TimeoffRequestsModel",
    "FlashService",
];
exports.default = InstructorRequestTimeOffRangeController;
